import React from 'react'
import { FacebookShareButton } from 'react-share'
import styled from 'styled-components'
import { FacebookIcon } from '../../Svg'
import { ShareButtonProps } from './types'

const StyledIcon = styled(FacebookIcon)`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.gray6};
`

const FacebookShare: React.FC<ShareButtonProps> = ({ url, title }) => {
  return (
    <FacebookShareButton url={url} title={title}>
      <StyledIcon />
    </FacebookShareButton>
  )
}

export default FacebookShare
